import playerKo from './locales/ko/player.json'
import playerEn from './locales/en/player.json'
import quizKo from './locales/ko/quiz.json'
import quizEn from './locales/en/quiz.json'

export const sharedLearningResources = {
  ko: {
    player: playerKo,
    quiz: quizKo,
  },
  en: {
    player: playerEn,
    quiz: quizEn,
  },
} as const

export { playerKo, playerEn, quizKo, quizEn }
